import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=662b3fa0"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports